import { render, staticRenderFns } from "./CTIAddress.vue?vue&type=template&id=535ece7a&scoped=true&"
import script from "./CTIAddress.vue?vue&type=script&lang=js&"
export * from "./CTIAddress.vue?vue&type=script&lang=js&"
import style0 from "./CTIAddress.vue?vue&type=style&index=0&id=535ece7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ece7a",
  null
  
)

export default component.exports